module.exports = __webpack_public_path__ + "media/images/compare-img3-befc820555d1bc10115bc2c895ad5dc1.png";